import type { UCConfigInterface } from '@/libraries/usercentrics/types';

import { hasCCPABanner } from '@/helpers/tracking';

export const UC_TCF_LOCALSTORAGE_KEY: string = 'uc_tcf';

// Hostname-based configuration
function isMovieCycleDomain(): boolean {
	// UserCentrics only runs on client side (in onMounted), so this is safe
	if (import.meta.server || typeof window === 'undefined') {
		// On server or when window is not available, default to production config
		// This is safe because UserCentrics is only initialized on the client
		return false;
	}

	// On client, check if hostname contains 'moviecycle'
	return window.location.hostname.includes('moviecycle');
}

export const TCF_PROFILE: UCConfigInterface = {
	// Use stage config (JZOgttDwQ) for moviecycle domains, production config (pNbv5DOWe) otherwise
	configId: isMovieCycleDomain() ? 'JZOgttDwQ' : 'pNbv5DOWe',
	isTCFEnabled: true,
};

export const CCPA_PROFILE: UCConfigInterface = {
	configId: 'p9i1nfAVcBcGYb',
	isTCFEnabled: false,
};

export function getUserCentricsConsentProfile(): UCConfigInterface {
	return hasCCPABanner() ? CCPA_PROFILE : TCF_PROFILE;
}
